import React from 'react'

export const DarkThemeContext = React.createContext<boolean>(false)

export const useDarkTheme = () => React.useContext(DarkThemeContext)
